export const fieldTypeData = [
  {
    id: 1,
    name: '露地畑',
  },
  {
    id: 2,
    name: '露地畑(ﾎｳﾚﾝｿｳ)',
  },
  {
    id: 3,
    name: '施設畑',
  },
  {
    id: 4,
    name: '果樹園',
  },
  {
    id: 5,
    name: '果樹園(ﾌﾞﾄﾞｳ等)',
  },
  {
    id: 6,
    name: '果樹園(ﾌﾞﾙ-ﾍﾞﾘ-)',
  },
  {
    id: 7,
    name: '常緑果樹',
  },
  {
    id: 8,
    name: '水田(クロボク土)',
  },
  {
    id: 9,
    name: '水田(その他土壌)',
  },
  {
    id: 10,
    name: '茶園',
  },
  {
    id: 11,
    name: '桑園',
  },
  {
    id: 12,
    name: '飼料作畑',
  },
  {
    id: 13,
    name: '花木',
  },
  {
    id: 14,
    name: '培土',
  },
];
